import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import styles from './Styles.module.scss';
const AddContactForm = ({ functionPerformed, user, add, change }) => {
    const [name, setName] = useState(user === null || user === void 0 ? void 0 : user.displayName);
    const [fetching, setFetching] = useState(false);
    useEffect(() => {
        if (change && user.nameWasGiven)
            setName(user.nameWasGiven);
    }, []);
    const submitContact = () => {
        if (name.length === 0)
            return;
        setFetching(true);
        const contact = Object.assign({}, user);
        if (user.displayName !== name)
            contact.nameWasGiven = name;
        else
            delete contact.nameWasGiven;
        functionPerformed(contact)
            .catch(() => console.log('error add contact'))
            .finally(() => setFetching(false));
    };
    return (_jsxs("div", { className: styles.group, style: { padding: '16px 8px', gap: '8px' }, children: [_jsx("div", { className: styles.item, children: _jsx("input", { type: 'text', minLength: 1, maxLength: 24, autoFocus: true, value: name, onChange: (e) => setName(e.target.value) }) }), _jsx("div", { className: styles.item, style: { textAlign: 'center' }, children: _jsx("button", { onClick: submitContact, disabled: fetching, children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C" }) })] }));
};
export default AddContactForm;
